import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AgendaEmpresaComponent } from './agenda-empresa.component';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    {path:'', component: AgendaEmpresaComponent}
  ])],
  exports: [RouterModule]
})
export class AgendaEmpresaRoutingModule { }
